import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { DatevApolloProvider } from './lib/ApolloClient.tsx';
import type { ManagerAuthContextValue } from './lib/ManagerAuthContext.tsx';
import { ManagerAuthProvider } from './lib/ManagerAuthContext.tsx';
import { StandortProvider } from './lib/StandortContext.tsx';
import { Layout } from './pages/Layout.tsx';
import { DatevAuthProvider } from './lib/DatevAuthContext.tsx';
import { LoginPage } from './pages/LoginPage.tsx';

export type DatevProps = ManagerAuthContextValue;

export function Datev(props: DatevProps) {
  return (
    <ManagerAuthProvider value={props}>
      <DatevApolloProvider>
        <Suspense fallback={null}>
          <StandortProvider>
            <DatevAuthProvider>
              <Routes>
                <Route index element={<Layout />}></Route>
                <Route path="login" element={<LoginPage />}></Route>
              </Routes>
            </DatevAuthProvider>
          </StandortProvider>
        </Suspense>
      </DatevApolloProvider>
    </ManagerAuthProvider>
  );
}
